import { forwardRef } from "react";

/**
 * A one-colour icon from /public, painted with a colour token so it follows the
 * theme palette — an <img> cannot, because the SVG's own fill is baked in.
 *
 *   <MaskIcon src="/icons/check.svg" className="h-5 w-5 bg-primary" />
 *
 * Give it a size and a `bg-*` token. Every painted part of the file takes that one
 * colour, so an icon with a white or tinted detail needs an inline SVG instead.
 */
// forwardRef: it is used as a Popover/Tooltip trigger, which positions off the ref.
const MaskIcon = forwardRef(
  ({ src, className = "", alt, style, ...rest }, ref) => (
    <span
      ref={ref}
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt || rest["aria-label"] || rest.onClick ? undefined : true}
      className={`mask-icon inline-block shrink-0 ${className}`.trim()}
      style={{
        WebkitMask: `url("${src}") center / contain no-repeat`,
        mask: `url("${src}") center / contain no-repeat`,
        ...style,
      }}
      {...rest}
    />
  )
);

MaskIcon.displayName = "MaskIcon";

export default MaskIcon;
